import {CHECK_COUPON_SUCCESS, CLEAR_COUPON} from "../actions/OrderActions";

const initialState = {
    coupon: {}
};

export default function OrderReducer(state = initialState, action) {
    switch (action.type) {
        case CHECK_COUPON_SUCCESS:
            return {...state, coupon: action.payload};

        case CLEAR_COUPON:
            return {...state, coupon: {}}
    }

    return state;
}